import { Box } from '@alf/uikit';

import styles from './index.module.css';

export const PlayerWrapper = ({ dataRole, children }) => (
  <Box
    data-role={dataRole}
    flex="0 0 auto"
    justify="center"
    align="center"
    className={styles.playerContainer}
  >
    {children}
  </Box>
);
